// extracted by mini-css-extract-plugin
export default {"clientWrapper":"client_clientWrapper__HDz1v","notFound":"client_notFound__FZbPC"};